/**
 * @fileoverview CSS module for styling CAT (Category) question components
 * Used for rendering category question containers with progress indicators and error states
 *
 * @example
 * // Usage in component:
 * import styles from './CAT.module.css';
 *
 * <div className={styles.container}>
 *   <div className={styles.progress}>
 *     <div>Progress indicator</div>
 *   </div>
 *   <div className={styles.error}>Error message</div>
 * </div>
 */


.container {
    height: 100%;
    display: flex;
    gap: 16px;
    flex-direction: column;
    flex-grow: 1;
}

.progress {
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 24px;
}

.error {
    color: #bd0100;
}
